import React, { forwardRef } from 'react';
import InputError from './InputError';
import InputLabel from './InputLabel';

const Input = forwardRef(function Input(
  {
    type = 'text',
    id,
    placeholder,
    autoComplete,
    required,
    label,
    error,
    value,
    onChange,
    disabled,
    onClick,
    onFocus,
  },
  ref,
) {
  return (
    <div className="flex w-full flex-col py-2">
      <InputLabel title={label} />
      <input
        className={`peer my-1 rounded-primary border-width-mini bg-white py-3 px-2 text-base placeholder:text-sm  ${
          error
            ? 'border-error focus-visible:outline-error'
            : 'border-grey-200 focus-visible:outline-blue-500'
        }`}
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        onClick={onClick}
        onFocus={onFocus}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        ref={ref}
        disabled={disabled}
        {...required}
      />
      <InputError id={id} error={error} />
    </div>
  );
});

export default Input;
